import axios from 'axios';
import { baseUrl } from "./config";
export const ajax = axios.create({
	baseURL: baseUrl,
	timeout: 0
});
// 添加请求拦截器
ajax.interceptors.request.use(
	(config) => {
		return config
	},
	(error) => {
		return Promise.reject(error)
	}
)
// 添加响应拦截器
ajax.interceptors.response.use(async function (response) {
	const {data} = response;
	return data.data;
}, async function (error) {
	console.log(error)
	// 对响应错误做点什么
	return Promise.reject(error.response.data);
});
export default ajax;
